/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Subheading_1Inputs */

const et_contact_subheading_1 = /** @type {(inputs: Contact_Subheading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kui sinu ettevõte sobib, liigud automaatselt edasi.`)
};

const en_contact_subheading_1 = /** @type {(inputs: Contact_Subheading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If your business qualifies, you'll move forward automatically.`)
};

/**
* | output |
* | --- |
* | "If your business qualifies, you'll move forward automatically." |
*
* @param {Contact_Subheading_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_subheading_1 = /** @type {((inputs?: Contact_Subheading_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Subheading_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_subheading_1(inputs)
	return en_contact_subheading_1(inputs)
});